import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import ServicesTable from "../../components/Tables/ServicesTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
class Services extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewServicePermission = userPermissions.includes('new service');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Servisler"
                Breadcrumb={[
                  {name: "Servisler", navigate: ""},

                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task">
                  <div className="header">
                    <h2>Servisler</h2>
                    {userHasNewServicePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/service-add">Yeni detaylı servis kaydı</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}

                  </div>
                  <div className="body">
                    <ServicesTable>

                    </ServicesTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(Services)));
